import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LockClosedIcon } from '@heroicons/react/24/solid';

import { NectarPageBlock, nectarPageBlock } from '~/utils/nectarPageBlock';

import { PillButton } from './ui/PillButton';

import { GateBannerCard } from './GateBannerCard';

interface UpgradeBannerProps {
  onUpgrade: () => void;
}

export const UpgradeBanner: FC<UpgradeBannerProps> = ({ onUpgrade }) => {
  const { t } = useTranslation();

  return (
    <GateBannerCard>
      <div className="flex size-12 items-center justify-center rounded-full bg-community-text-on-bg/10">
        <LockClosedIcon aria-hidden="true" className="size-5 text-community-text-on-bg/80" />
      </div>
      <h2 className="mt-4 text-xl font-semibold leading-7 tracking-[-0.4px]">{t('community.paid_gate.title')}</h2>
      <p className="mt-2 max-w-md text-sm leading-5 text-community-text-on-bg/60">
        {t('community.join.paid_tier_prompt')}
      </p>
      <PillButton
        type="button"
        onClick={onUpgrade}
        variant="primary"
        className="mt-6"
        {...nectarPageBlock(NectarPageBlock.CommunityFeedUpgradeButton)}
      >
        {t('community.paid_gate.cta')}
      </PillButton>
    </GateBannerCard>
  );
};
